module.exports = __webpack_public_path__ + "static/img/amp-higain.4024c45.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/amp-higain.png
// module id = UN3g
// module chunks = 12